import angular from 'angular';
import commissionFilterInline from './commissionFilterInline';
import './style.scss';

export default angular
  .module('commission.components.commissionFilterInline', [])
  .component('commissionFilterInline', commissionFilterInline).name;
